module.exports = __webpack_public_path__ + "img/exam-hero-background@1.5x.51409f8d.png";